import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { HcoService } from '../../hco/hco.service';
import { HCPHCO } from "../../../../models/lookups/hcpHco.model";
import { DisplayModes } from "../../../../models/enums";
import { AppConfigService } from "../../../../app.config";
import { ModalDirective } from "ngx-bootstrap";
import { HCO } from '../../../../models/lookups/hco.model';
import { Page } from '../../../../models/page.model';
import { AppTranslationService } from '../../../../services/app-translation.service';
import { AlertService, MessageSeverity } from '../../../../services/alert.service';
import { Utilities } from '../../../../services/utilities';


// HCP lookup → Edit HCOs: request links between one HCP and HCOs in the user's own area (bricks, organization types and
// specialities, limited by the server too). Saving requests the newly ticked links and the unlink of links the user
// unticked; links outside the user's area are never shown here and never touched.
@Component({
  selector: 'crm-add-hco-hcp',
  templateUrl: './add-hco-hcp.component.html',
  styleUrls: ['./add-hco-hcp.component.css']
})
export class AddHcoHcpComponent implements OnInit {
  @ViewChild(ModalDirective) modal: ModalDirective;

  @Input() hcpId: number;
  // true when saved, so the caller can refresh its counts
  @Output() closeModalEvent = new EventEmitter<boolean>();

  hcos: HCO[] = [];
  hcpHcos: HCPHCO[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  currentPage: number = 1;
  first: number = 0;
  pageSize = this.appConfig.settings.pageSize;
  firstList: boolean = true;
  totalItems: number = 0;
  selectedHcosIds: number[] = [];
  // the HCOs the HCP is linked to now; unticking one of them requests its unlink
  linkedHcoIds: number[] = [];
  linksLoaded: boolean = false;
  saving: boolean = false;
  searchText;
  bricks: { id: number, name: string }[] = [];
  specialitys: { id: number, name: string }[] = [];
  organizationTypes: { id: number, name: string }[] = [];
  search: any = {};
  constructor(private hcoService: HcoService, private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService,
    private readonly appConfig: AppConfigService) {
  }

  ngOnInit() {
    this.getLinkAreaLookups();
    if (this.hcpId != undefined)
      this.getHcpHcos(this.hcpId);
  }

  // the Search button and Enter in the search box: always search from page one, never save
  onSearch(event?: Event) {
    if (event)
      event.preventDefault();
    this.currentPage = 1;
    this.first = 0;
    this.getHcos();
  }

  getHcos() {
    const organizationTypeId = this.search.organizationType ? this.search.organizationType.id : 0;
    const brickId = this.search.brick ? this.search.brick.id : 0;
    const specialityId = this.search.speciality ? this.search.speciality.id : 0;

    this.hcoService.searchHcosForLink(this.searchText, brickId, organizationTypeId, specialityId, this.pageSize, this.currentPage).subscribe(response => {
      let results = response as Page;
      this.hcos = [];

      results.items.forEach(x => {
        if (this.hcos.filter(y => y.id == x.id).length == 0)
          this.hcos.push(x);
      })
      this.totalItems = results.totalItems;
      this.displayMode = DisplayModes.Success;
      this.hcos.forEach((hco) => {
        hco.selected = this.selectedHcosIds.indexOf(hco.id) > -1;
      })

    }, err => {
      this.displayMode = DisplayModes.Error;
    });
  }

  pageChanged(event) {
    this.first = event.first;
    this.currentPage = event.first / event.rows + 1;
    if (!this.firstList)
      this.getHcos();
    else
      this.firstList = !this.firstList;
  }

  onSelectHco(hco) {
    if (hco.selected) {
      if (this.selectedHcosIds.indexOf(hco.id) == -1)
        this.selectedHcosIds.push(hco.id);
    }
    else {
      let index = this.selectedHcosIds.indexOf(hco.id);
      if (index > -1)
        this.selectedHcosIds.splice(index, 1);
    }
  }

  save() {
    if (!this.linksLoaded || this.saving)
      return;
    const removedHcoIds = this.linkedHcoIds.filter(id => this.selectedHcosIds.indexOf(id) == -1);
    this.saving = true;
    this.hcoService.addHcpHcos(this.hcpId, this.selectedHcosIds.slice(), removedHcoIds).subscribe(response => {
      this.saving = false;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      this.closeModalEvent.emit(true);
    }, err => {
      this.saving = false;
      this.alertService.showStickyMessage("Save Error", Utilities.validationMessage(err, "The HCO links weren't saved."), MessageSeverity.Error, err);
    });
  }

  getHcpHcos(hcpId) {
    this.hcoService.getHcpHcosByHcpId(hcpId).subscribe(response => {
      this.hcpHcos = (response as HCPHCO[]) || [];
      this.linkedHcoIds = this.hcpHcos.map(x => x.hcoId);
      this.selectedHcosIds = this.linkedHcoIds.slice();
      this.linksLoaded = true;

      this.getHcos();

    }, err => {
      this.displayMode = DisplayModes.Error;
    });
  }

  back() {
    this.closeModalEvent.emit(false);
  }

  getLinkAreaLookups() {
    this.hcoService.getLinkAreaLookups().subscribe((response: any) => {
      this.bricks = response.bricks || [];
      this.organizationTypes = response.organizationTypes || [];
      this.specialitys = response.specialities || [];
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }

}
